import { combineReducers } from 'redux'
import { commonPatentsSlice } from './common'
import { transportPatentsSlice } from './transport'
import { realtyPatentsSlice } from './realty'

export * from './common'
export * from './realty'
export * from './transport'

export const patentsSlice = combineReducers({
	[commonPatentsSlice.name]: commonPatentsSlice.reducer,
	[transportPatentsSlice.name]: transportPatentsSlice.reducer,
	[realtyPatentsSlice.name]: realtyPatentsSlice.reducer,
})
